import { takeLatest, call, put, select, all } from 'redux-saga/effects'
import { replace } from 'react-router-redux'

import {
  LOGIN_SHOW_LOADING,
  LOGIN_HIDE_LOADING
} from '../routes/Login/modules/reducer'
import { login } from '../api/profile'
import { getUserRoles, getHouseMaster } from '../api/employee'
import { showNotification, hideNotification, toggleProfile } from './global'
import { pushLocation } from './location'
import {
  setAuthenticationToken,
  getUserData,
  removeAuthenticationToken
} from '../utils/token'
import { changeTheme } from './theme'
import configureAxiosSetting from '../api/apiConfiguration'

/**
|--------------------------------------------------
| Constants
|--------------------------------------------------
*/
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const CHANGE_AVATAR = 'CHANGE_AVATAR'
export const USER_UPDATE = 'USER_UPDATE'

export const REPEAT_CHECK_ROLE = 'REPEAT_CHECK_ROLE'
export const REPEAT_CHECK_ROLE_SUCCESS = 'REPEAT_CHECK_ROLE_SUCCESS'

/**
|--------------------------------------------------
| Actions
|--------------------------------------------------
*/
export const onLogin = ({ user, password }) => ({
  type: LOGIN_REQUEST,
  payload: { user, password }
})

export const onLogout = () => ({
  type: LOGOUT_REQUEST
})

export const changeAvatar = avatar => ({
  type: CHANGE_AVATAR,
  avatar
})

export const repeatCheckRole = () => ({
  type: REPEAT_CHECK_ROLE
})

/**
|--------------------------------------------------
| Handlers
|--------------------------------------------------
*/
const ActionHandler = {
  [LOGIN_SUCCESS]: (currentState, action) => ({
    ...currentState,
    user: action.user,
    permissions: action.permissions
  }),
  [REPEAT_CHECK_ROLE_SUCCESS]: (currentState, action) => ({
    ...currentState,
    user: action.user,
    permissions: action.permissions
  }),
  [LOGOUT_SUCCESS]: (currentState, action) => ({
    ...currentState,
    user: null,
    permissions: []
  }),
  [CHANGE_AVATAR]: (currentState, action) => ({
    ...currentState,
    user: {
      ...currentState.user,
      Avatar: action.avatar
    }
  }),
  [USER_UPDATE]: (currentState, action) => ({
    ...currentState,
    user: { ...action.user }
  })
}

/**
|--------------------------------------------------
| Reducer
|--------------------------------------------------
*/
const initialState = {
  user: null,
  permissions: [],
  retry: 0
}

export default function authentication(
  currentState = { ...initialState },
  action
) {
  const handler = ActionHandler[action.type]
  const nextState = handler ? handler(currentState, action) : currentState
  return nextState
}

function* loginWorker({ payload }) {
  try {
    yield put({ type: LOGIN_SHOW_LOADING })
    const response = yield call(login, payload)

    if (response.result === 'fail') {
      throw new Error(response.errorMessage)
    }

    setAuthenticationToken(response.token)

    configureAxiosSetting()

    const user = getUserData()

    const roles = yield call(getUserRoles, user.EmployeeId)

    if (roles.HasError) {
      throw new Error(roles.Error)
    }

    yield put({ type: LOGIN_SUCCESS, user, permissions: roles.Data || [] })
    yield put(changeTheme(user.CompanyCode || 'DS'))
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
    yield put({ type: LOGIN_FAILURE })
  } finally {
    yield put({ type: LOGIN_HIDE_LOADING })
  }
}

function* onLoginSuccess({ user }) {
  try {
    const { returnUrl } = yield select(({ location }) => location.query)

    yield put(hideNotification())
    // const response = yield call(getHouseMaster, user.EmployeeId)
    // if (response.HasError) {
    //   throw new Error(response.Error)
    // }

    let pathname = returnUrl

    // if (!response.Data) {
    //   pathname = 'family-members'
    // }

    yield put(replace(pathname || '/'))
  } catch (error) {
    const message =
      (error.response && error.response.data.Message) || error.message
    yield put(showNotification(message, 30000, true))
  }
}

function* logoutWorker() {
  removeAuthenticationToken()
  yield put(pushLocation('/login'))
  yield put(toggleProfile(false))
  yield put({ type: LOGOUT_SUCCESS })
}

function* onCheckRole() {
  const user = getUserData()

  if (user === null) {
    return true
  }
  if(isNaN(user.EmployeeId)) {
    yield put({
      type: REPEAT_CHECK_ROLE_SUCCESS,
      user,
      permissions: []
    })
    return;
  }
  const roles = yield call(getUserRoles, user.EmployeeId)

  if (roles.HasError) {
    throw new Error(roles.Error)
  }
  let data = roles.Data || [];
  yield put({
    type: REPEAT_CHECK_ROLE_SUCCESS,
    user,
    permissions: data
  })
  // if (roles.Data.length) {
  //   yield put({
  //     type: REPEAT_CHECK_ROLE_SUCCESS,
  //     user,
  //     permissions: roles.Data
  //   })
  //   yield put(changeTheme(user.CompanyCode || 'DS'))
  // } else {
  //   yield put({ type: LOGOUT_REQUEST })
  // }
}

function* authenticationWatcher() {
  yield all([
    takeLatest(LOGIN_REQUEST, loginWorker),
    takeLatest(LOGIN_SUCCESS, onLoginSuccess),
    takeLatest(LOGOUT_REQUEST, logoutWorker),
    takeLatest(REPEAT_CHECK_ROLE, onCheckRole)
  ])
}

export const saga = [authenticationWatcher()]



// WEBPACK FOOTER //
// ./src/store/authentication.js